module.exports = __webpack_public_path__ + "static/img/map.ad7d3d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map.png
// module id = /PMo
// module chunks = 0